module.exports = {
  size: function (bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (!bytes) return ''
    if (bytes === 0) return '0 Byte'
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i]
  }
}



// WEBPACK FOOTER //
// ./src/helpers/math.js